import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFetch } from "../../../hooks/api";
import useColumnSelector from "../../../hooks/useColumnSelector";
import ReactTable from "react-table-6";
import ReactTablePagination from "../../../components/custom/growth/ProductsCVTablePagination";
import Loading from "../../../components/core/blocks/Loading";
import moment from "moment";
import { getURLPrefix } from "../../../utils/getUrlPrefix";
import axios from "axios";
import { HiDownload } from "react-icons/hi";
import FileSaver from "file-saver";

const API_URL = getURLPrefix();

const B2BFeed = ({ marketPlace }) => {
  const { t } = useTranslation(["pricingv2"]);
  const [colToggle] = useState();

  const { data, isLoading } = useFetch(
    ["B2BFeed", marketPlace.marketPlace],
    `/pricing/b2bfeedstatus/`,
    {
      marketplace: marketPlace.marketPlace,
    },
    {
      default: [],
      select: (d) => d.data,
    },
  );

  const handleDownload = async (id, title) => {
    const url = `${API_URL}/api/exports/${id}/download/`;
    const response = await axios({
      method: "GET",
      url: url,
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "text/xml;charset=utf-8",
    });

    FileSaver.saveAs(blob, `${title}.xml`);
  };

  const tableRef = useRef();

  const [columns, columnSelectorProps] = useColumnSelector(() => {
    const columns = [
      {
        id: "Feed ID",
        label: "Feed ID",
        Header: () => <span style={{ position: "relative" }}>{t(($) => $.pricingv2["Feed ID"])}</span>,
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "left" },
        style: { textAlign: "left" },
        accessor: "id",
      },
      {
        id: "Status",
        label: "Status",
        Header: () => <span style={{ position: "relative" }}>{t(($) => $.pricingv2["Status"])}</span>,
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "left" },
        style: { textAlign: "left" },
        accessor: "status",
      },
      {
        id: "Created",
        label: "Created",
        Header: () => <span style={{ position: "relative" }}>{t(($) => $.pricingv2["Created"])}</span>,
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "left" },
        style: { textAlign: "left" },
        accessor: "created_on",
        Cell: (props) => {
          return <div>{moment(props.value).format("MMM DD YYYY")}</div>;
        },
      },
      {
        id: "Processed",
        label: "Processed",
        Header: () => <span style={{ position: "relative" }}>{t(($) => $.pricingv2["Created"])}</span>,
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        accessor: "result",
        Cell: (props) => {
          return <div>{props.value?.Message?.ProcessingReport?.ProcessingSummary?.MessagesProcessed}</div>;
        },
      },
      {
        id: "Success",
        label: "Success",
        Header: () => <span style={{ position: "relative" }}>{t(($) => $.pricingv2["Successful"])}</span>,
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        accessor: "result",
        Cell: (props) => {
          return <div>{props.value?.Message?.ProcessingReport?.ProcessingSummary?.MessagesSuccessful}</div>;
        },
      },
      {
        id: "Error",
        label: "Error",
        Header: () => <span style={{ position: "relative" }}>{t(($) => $.pricingv2["Error"])}</span>,
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        accessor: "result",
        Cell: (props) => {
          return <div>{props.value?.Message?.ProcessingReport?.ProcessingSummary?.MessagesWithError}</div>;
        },
      },
      {
        id: "Warning",
        label: "Warning",
        Header: () => <span style={{ position: "relative" }}>{t(($) => $.pricingv2["Warning"])}</span>,
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        accessor: "result",
        Cell: (props) => {
          return <div>{props.value?.Message?.ProcessingReport?.ProcessingSummary?.MessagesWithWarning}</div>;
        },
      },
      {
        id: "Download",
        label: "Download",
        Header: () => <span style={{ position: "relative" }}>{t(($) => $.pricingv2["Download"])}</span>,
        headerClassName: "wordwrap",
        headerStyle: { textAlign: "center" },
        style: { textAlign: "center" },
        accessor: "export",
        Cell: (props) => {
          return (
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDownload(props.value.id, `b2b_feed_${props.value.id}`);
              }}
            >
              <HiDownload />
            </span>
          );
        },
      },
    ];

    return columns;
  }, [colToggle, t]);
  if (isLoading) return <Loading fullPage={false} />;

  return (
    <ReactTable
      ref={tableRef}
      data={data.results}
      className="b2b-table"
      PaginationComponent={(props) => {
        return (
          <ReactTablePagination
            {...props}
            table={"b2b-table"}
            showFilters={false}
            style={{ marginBottom: "2rem" }}
            carouselLayout={true}
            hideFilters={true}
            columnSelectorProps={columnSelectorProps}
            hideSearch={false}
          />
        );
      }}
      columns={columns}
      defaultPageSize={20}
      NoDataComponent={() => null}
      minRows={0}
      showPaginationTop
      showPaginationBottom={false}
      filterable={false}
    />
  );
};

export default B2BFeed;
